import { render, staticRenderFns } from "./team-goods-add.vue?vue&type=template&id=4a58f0e8&scoped=true&"
import script from "./team-goods-add.vue?vue&type=script&lang=js&"
export * from "./team-goods-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a58f0e8",
  null
  
)

export default component.exports